<template>
    <div >
        <div class="col-md-12 col-sm-12" v-if="showForm">
            <div class="form-group" v-if="vmrs.length > 0">
                <label>{{ $t('use_this_room') }}</label>
                <multiselect
                    :options="vmrs"
                    v-model="vmr"
                    :search="true"
                    :taggable="true"
                    :showLabels="false"
                    :placeholder="$t('select_option')"
                    track-by="id"
                    label="nombre"
                />
            </div>

            <div class="checkbox" v-if="can_record">
                <label>
                    <input type="checkbox" v-model="record">
                    {{ $t('record_meeting') }}
                </label>
            </div>
            <div class="checkbox">
                <label>
                    <input type="checkbox" v-model="call_members">
                    {{ $t('call_members') }}
                </label>
            </div>
            <div class="checkbox">
                <label>
                    <input type="checkbox" v-model="use_pin" >
                    {{ $t('use_pin') }}
                </label>
            </div>
            <div class="form-group" v-if="contacts.length > 0">
                <label>{{ $t('participants') }}</label>
                <multiselect
                    :options="contacts"
                    v-model="participants"
                    :search="true"
                    :multiple="true"
                    :taggable="false"
                    :showLabels="false"
                    :placeholder="$t('select_option')"
                    :close-on-select="false"
                    track-by="id"
                    label="nombre"
                />
            </div>

            <vue-simple-spinner size="80" line-size="12" :npmessage="$t('doing_meeting')" v-if="doingMeeting"></vue-simple-spinner>
            <input type="submit" class="btn btn-lg btn-success btn-block"
                @click="createMeet" :value="$t('create_meeting')" v-if="!doingMeeting"
            />

        </div>
        <div class="col-md-12 col-sm-12" v-if="showInfo">
            {{ $t('meeting_info')}}
            <ul>
                <li><strong>{{ $t('subject') }}: </strong>{{ meetResultData.asunto }}</li>
                <li><strong>{{ $t('sip_uri')}}: </strong>{{ meetResultData.sip_uri }}</li>
            </ul>
            {{ $t('participant_booking_added', {email: bookingOutlookAddress}) }}
        </div>
        <div class="col-md-12 col-sm-12" v-if="showReserved">
            {{ $t('meeting_reserved') }}
        </div>
        <div class="col-md-12 col-sm-12" style="margin: 30px 0;" v-if="!doingMeeting">
            <input type="submit" class="btn btn-lg btn-danger btn-block"
                @click="logout"
                :value="$t('logout')"
            />
        </div>
    </div>
</template>

<script>

import addinConfig from '../helpers/addin-config.js'
import tpaas from '../helpers/tpaas.js'
import outlookMeet from '../helpers/outlook-meet.js'
import Multiselect  from 'vue-multiselect'

import Spinner from 'vue-simple-spinner'

export default {
    name: 'Meeting',
    components: {
        Multiselect,
        'vue-simple-spinner': Spinner
    },
    props: {
        can_record: {
            type: Boolean,
            default: false
        },
        username: {
            type: String,
            default: null,
        },
        password: {
            type: String,
            default: null,
        },
        contacts: {
            type: Array,
            default: [],
        },
        vmrs: {
            type: Array,
            default: []
        }
    },
    data: function () {
        return  {
            bookingOutlookAddress: 'booking.outlook@tpaas.es',
            call_members: false,
            use_pin: true,
            record: false,
            vmr: null,
            participants: null,
            meeting: null,
            doingMeeting: false,
            validateMessage: '',
            validatedComplete: {},
            meetingParams: {},
            meetCreated: false,
            meetReserved: false,
            meetResultData: null,
        }
    },
    computed: {
        showForm() {
            return !this.meetCreated && !this.meetReserved;
        },
        showInfo() {
            return this.meetCreated && !this.meetReserved;
        },
        showReserved() {
            return !this.meetCreated && this.meetReserved;
        }
    },
    mounted() {
        if (Office.context.mailbox) {
            this.meeting = Office.context.mailbox.item;
            this.meeting.requiredAttendees.getAsync(this.checkReserved);
        }
    },
    methods: {
        logout: function() {
            addinConfig.eraseConfig();
            this.$emit("logout");
        },
        checkReserved(results) {
            var self = this;
            var search = results.value.filter(item => item.emailAddress == self.bookingOutlookAddress);
            this.meetReserved = (search.length > 0);
        },
        createMeet: function() {
            this.meetingParams = {};
            this.validateMessage = '';
            if (!this.meeting) {
                this.validateMessage = this.$i18n.t('no_appoinment');
                this.checkValidation('meet');
                return;
            }
            this.validatedComplete['subject'] = false;
            this.validatedComplete['start'] = false;
            this.validatedComplete['end'] = false;
            this.validatedComplete['optionalAttendees'] = false;
            this.validatedComplete['requiredAttendees'] = false;

            // Estas llamadas son asincronas y cada una acabará llamando a checkValidation
            outlookMeet.readSubject(this.meeting, this, this.$i18n.t('need_meeting_subject'));
            outlookMeet.readStart(this.meeting, this, this.$i18n.t('need_meeting_start'));
            outlookMeet.readEnd(this.meeting, this, this.$i18n.t('need_meting_end'));
            outlookMeet.readOptionalAttendes(this.meeting, this);
            outlookMeet.readRequiredAttendes(this.meeting, this, this.bookingOutlookAddress);
        },

        // Este es el callback para todas las llamadas asincronas de lectura de datos de la api de outlook
        checkValidation(property) {
            if (this.validateMessage != '') {
                this.$emit('message', this.validateMessage);
                return;
            }

            this.validatedComplete[property] = true;
            // Para continuar con la ejecución todas las validaciones han de estar completas
            for(var prop in this.validatedComplete) {
                if (!this.validatedComplete[prop])
                    return;
            }
            this.meetingParams['vmr'] = this.vmr;
            this.meetingParams['record'] = this.record;
            this.meetingParams['devices'] = this.participants,
            this.meetingParams['use_pin'] = this.use_pin;
            this.meetingParams['call_members'] = this.call_members;
            this.meetingParams['from'] = Office.context.mailbox.userProfile.emailAddress;

            var self = this;
            // Aqui ya se compone la reunión
            this.doingMeeting = true;
            tpaas.createMeet(this.username, this.password, this.$root.$i18n.locale, this.meetingParams)
            .then(this.updateItem)
            .catch(function (error) {
                console.log(error);
                self.doingMeeting = false;
                if (error != '')
                    self.$emit('message', error);
            });
        },

        // Este es el callback cuando la llamada de la API finalizó con éxito, aunque puede ser con o sin errores
        updateItem(data) {
            this.doingMeeting = false;
            // Todo ok podemos informar de que todo ha salido bien
            if (data.result == 'ok') {
                this.meeting.body.prependAsync(data.body, { coercionType: Office.CoercionType.Html });
                this.meeting.requiredAttendees.addAsync([this.bookingOutlookAddress]);
                this.meetCreated = true;
                var message = this.$i18n.t('meeting_created');
                this.meetResultData = data.meet_data;
                if (message != '')
                    this.$emit('message', message , 'success');
                return;
            }
            if (data.message != '')
                this.$emit('message', data.message);
        }
    }
}
</script>

<style src="bootstrap/dist/css/bootstrap.min.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tag {
    background: #197C9F;
}

.multiselect__option--highlight {
    background: #72C0C8;
}

.multiselect__tag-icon:after  {
    color: white;
}

.multiselect__tag-icon:hover {
    background: #b70018;
}

.multiselect__option--selected.multiselect__option--highlight {
    background: #ffa7a7;
}

.btn-success, .btn-success:focus {
    background-color: #197c9f;
    border-color: #0c5b77;
}

.btn-success:hover, .btn-success:active, .btn-success:active:focus, .btn-success:hover:focus {
    background-color: #0b3b4d;
    border-color: #0c5b77;
}

</style>


// WEBPACK FOOTER //
// src/components/Meeting.vue